import { ReactNode, useEffect, useRef, useState } from 'react';
import ModalForm, { ModalFormProps } from '../ModalForm';
import { Box, TextField } from '@mui/material';
import { GroupLabels } from '../../../entities/Group';
import axios from 'axios';
import { useDerivate } from '../../../requests/derivate';
import { FormType } from '../../../enums/form-type.enum';
import SearchableSelect from '../../SearchableSelect';

interface DerivateModalProps
	extends Omit<ModalFormProps, 'children' | 'formType'> {
	children?: ReactNode;
	clientId: number;
	handleSaveParent: Function;
}
export default function DerivateModal({
	open,
	handleClose,
	title,
	clientId,
	handleSaveParent,
}: DerivateModalProps) {
	const derivate = useDerivate();
	const formRef = useRef(null);
	const [form, setForm] = useState({ groupId: '' });
	const [groups, setGroups] = useState<GroupLabels[]>([]);
	const [client, setClient] = useState<{ groupName: string | null }>();
	const [errors, setErrors] = useState({ serverError: '' });

	useEffect(() => {
		axios
			.request({ method: 'GET', url: `/clients/${+clientId}/group-name` })
			.then((response) => {
				setClient(response.data);
			})
			.catch((error) => console.error(error));
		axios
			.request({ method: 'GET', url: `/groups/labels` })
			.then((response) => {
				setGroups(response.data.data);
			})
			.catch((error) => console.error(error));

		return setForm({ groupId: '' });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChange = (e: any): void => {
		setForm({
			...form,
			[e.target.name]: e.target.value,
		});
	};

	const handleSave = async () => {
		try {
			await derivate(+clientId, form);
			handleSaveParent();
			handleClose();
		} catch (error: any) {
			if (error.code === 'ERR_NETWORK')
				setErrors({ ...errors, serverError: 'true' });
		}
	};

	//modal form ref

	return (
		<ModalForm
			open={open}
			handleClose={handleClose}
			title={title}
			formRef={formRef}
			formType={FormType.DERIVATE}
			hasServerError={!!errors?.serverError}
		>
			<Box
				component="form"
				sx={{
					'& .MuiTextField-root, .MuiFormControl-root': {
						m: 1,
						marginInline: 3,
						width: '25ch',
					},
				}}
				autoComplete="off"
				ref={formRef}
				onSubmit={(e) => {
					e.preventDefault();
					handleSave();
				}}
			>
				<TextField
					id="currentGroup"
					name="currentGroup"
					disabled
					label="Grupo actual"
					value={client?.groupName || 'Ninguno'}
					variant="standard"
				/>
				<SearchableSelect
					label="Derivar a"
					items={groups}
					defaultValue={''}
					valueProperty="name"
					idProperty="id"
					value={form?.groupId}
					onChange={handleChange}
					name="groupId"
					width="25ch !important"
					required={true}
				/>
			</Box>
		</ModalForm>
	);
}
